import React from "react";
import PropTypes from "prop-types";
import DraggableButtons from "../../../components/draggableButtons/draggableButtons";
import { connect } from "react-redux";
import { actionCreators } from "./redux/sagas/dashboardConfigurator/dashboardConfigurator";

export class DashboardConfigurator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboardPreferences: []
    };
    this.onListChange = this.onListChange.bind(this);
  }

  componentDidMount() {
    const globalOverlayDomEl = document.getElementById("globalOverlay");
    const dashBoardConfiguratorDomEl = document.getElementById("dashBoardConfigurator");

    this.props.fetchCurrentPreferences(this.props.currentUser);
    this.setState({
      dashboardPreferences: this.props.currentUser.dashboardPreferences
    });

    globalOverlayDomEl.addEventListener("click", () => {
      this.props.toggleShowSettings(false);
      globalOverlayDomEl.classList.remove("active");

      if (dashBoardConfiguratorDomEl) {
        dashBoardConfiguratorDomEl.classList.remove("active");
      }
    });

    setTimeout(() => {
      this.reorderDashboardPreferences(this.state.dashboardPreferences);
    }, 1000);
  }

  componentDidUpdate() {
    //this.reorderDashboardPreferences(this.state.dashboardPreferences);
    this.showModules();
  }

  showModules() {
    let filteredArray = [];
    this.state.dashboardPreferences
      .filter((pref) => {
        return pref.active;
      })
      .map((pref) => {
        filteredArray.push(pref);
        const name = pref.name.replace(/\s/g, "").toLowerCase();
        const customModuleWrapperDomEl = document.getElementById(name + "ModuleWrapper");
        if (customModuleWrapperDomEl) {
          customModuleWrapperDomEl.classList.add("active");
        }
      });
  }

  toggleSettings = () => {
    const globalOverlayDomEl = document.getElementById("globalOverlay");
    const dashBoardConfiguratorDomEl = document.getElementById("dashBoardConfigurator");

    if (this.props.showSettings) {
      this.props.toggleShowSettings(false);
      if (globalOverlayDomEl) {
        globalOverlayDomEl.classList.remove("active");
      }

      if (dashBoardConfiguratorDomEl) {
        dashBoardConfiguratorDomEl.classList.remove("active");
      }
    } else {
      this.props.toggleShowSettings(true);
      if (globalOverlayDomEl) {
        globalOverlayDomEl.classList.add("active");
      }

      if (dashBoardConfiguratorDomEl) {
        dashBoardConfiguratorDomEl.classList.add("active");
      }
    }
  };

  onListChange(newList) {
    let newListFiltered = [];

    newList
      .filter((pref) => {
        return pref.active;
      })
      .map((pref) => {
        newListFiltered.push(pref);
      });
    this.setState({
      dashboardPreferences: newList
    });
    this.props.updateDashboardPreferences(newListFiltered);
    this.reorderDashboardPreferences(this.state.dashboardPreferences);
  }

  reorderDashboardPreferences(dashboardPreferences) {
    const parentElement = document.getElementById("dashboardModulesWrapper");
    // get our dashboard preferences elements in order that was returned
    const dashboardPreferenceElements = dashboardPreferences
      // .reverse() // for easy debugging
      .map((pref) => pref.name.replace(/\s/g, "").toLowerCase() + "ModuleWrapper")
      .map((id) => document.getElementById(id));

    // clear out the parent element
    parentElement.innerHTML = "";
    // re add the elements in the order that we want.
    dashboardPreferenceElements.forEach((el) => {
      // In case this element doesn't exist in the dom, then don't append
      if (el) {
        parentElement.appendChild(el);
      }
    });
  }

  render() {
    return (
      <div>
        <button onClick={this.toggleSettings} style={{ outline: "none" }}>
          Dashboard Settings
        </button>
        <div
          className={`configurator-container ${this.props.showSettings && "active"}`}
          style={{
            position: "absolute",
            minWidth: "350px",
            right: -13,
            zIndex: 201,
            display: "none"
          }}
        >
          <DraggableButtons onListChange={this.onListChange} list={this.state.dashboardPreferences} onButtonChange={this.onListChange}>
            <h3>Customize your Modules</h3>
            <p className="instructions">
              Click on Module number to toggle display. Drag <span className="arrows">▲</span> or <span className="arrows">▼</span> to adjust position.
            </p>
          </DraggableButtons>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    dashboardPreferences: state.dashboardConfigurator.preferences,
    showSettings: state.dashboardConfigurator.showSettings,
    lightTheme: state.dashboardConfigurator.lightTheme
  }),
  {
    fetchCurrentPreferences: actionCreators.fetchCurrentPreferences,
    updateDashboardPreferences: actionCreators.updateDashboardPreferences,
    updateThemePreferences: actionCreators.updateThemePreferences,
    toggleShowSettings: actionCreators.showSettings
  }
)(DashboardConfigurator);

DashboardConfigurator.propTypes = {
  currentUser: PropTypes.object,
  fetchCurrentPreferences: PropTypes.func.isRequired,
  updateDashboardPreferences: PropTypes.func.isRequired,
  updateThemePreferences: PropTypes.func.isRequired,
  toggleShowSettings: PropTypes.func,
  dashboardPreferences: PropTypes.array,
  showSettings: PropTypes.bool
};
